import { render, staticRenderFns } from "./log_item.vue?vue&type=template&id=8cdf8cec&scoped=true"
import script from "./log_item.vue?vue&type=script&lang=js"
export * from "./log_item.vue?vue&type=script&lang=js"
import style0 from "./log_item.vue?vue&type=style&index=0&id=8cdf8cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdf8cec",
  null
  
)

export default component.exports